import { env } from '$env/dynamic/public';
import { HttpError } from '$lib/HttpError';

export async function getLaunches(
  /** @type {(input: RequestInfo | URL, init?: RequestInit) => Promise<Response>} */ fetch,
  /** @type number */ currentPage,
  /** @type number */ pageSize,
  isLaunched = false,
  /** @type any */ launchTypes = []
) {
  let endpoint = `${env.PUBLIC_LAUNCH_SERVICE_BASE_URL}launches/public?pageIndex=${currentPage}&pageSize=${pageSize}&isLaunched=${isLaunched}`;
  launchTypes.forEach((/** @type any */ launchType) => {
    endpoint += `&launchTypes=${launchType}`;
  });
  const response = await fetch(endpoint);
  if (!response.ok) {
    throw new HttpError(response.status);
  }
  return await response.json();
}

export async function getLaunch(
  /** @type {(input: RequestInfo | URL, init?: RequestInit) => Promise<Response>} */ fetch,
  /** @type {string} */ idLaunch
) {
  const response = await fetch(`${env.PUBLIC_LAUNCH_SERVICE_BASE_URL}launches/public/${idLaunch}`);
  if (!response.ok) {
    throw new HttpError(response.status);
  }
  return await response.json();
}

export async function getOperators(
  /** @type {(input: RequestInfo | URL, init?: RequestInit) => Promise<Response>} */ fetch
) {
  const response = await fetch(
    `${env.PUBLIC_LAUNCH_SERVICE_BASE_URL}launches/public/operators?isLaunched=false`
  );
  if (!response.ok) {
    throw new HttpError(response.status);
  }
  return await response.json();
}

export async function getVehicles(
  /** @type {(input: RequestInfo | URL, init?: RequestInit) => Promise<Response>} */ fetch
) {
  const response = await fetch(
    `${env.PUBLIC_LAUNCH_SERVICE_BASE_URL}launches/public/vehicles?isLaunched=false`
  );
  if (!response.ok) {
    throw new HttpError(response.status);
  }
  return await response.json();
}

export async function getSites(
  /** @type {(input: RequestInfo | URL, init?: RequestInit) => Promise<Response>} */ fetch
) {
  const response = await fetch(
    `${env.PUBLIC_LAUNCH_SERVICE_BASE_URL}launches/public/sites?isLaunched=false`
  );
  if (!response.ok) {
    throw new HttpError(response.status);
  }
  return await response.json();
}

export function getVehicleImageUrl(/** @type string */ idVehicle) {
  return `${env.PUBLIC_LAUNCH_SERVICE_BASE_URL}vehicles/${idVehicle}/image`;
}
